import styled from 'styled-components';

export const TableRoot = styled.table`
    display: table;
    width: 100%;
    border-collapse: ${(props) => props.collapse ? props.collapse : 'separate'};
    border-spacing: 0;
`;
